module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Mamas Pizza","short_name":"mamas","start_url":"/","background_color":"#000000","theme_color":"#e51937","display":"minimal-ui","icon":"src/images/logoBlackBorder.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"e24d95be8ed4aeceaf9745a6b71e4af8"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
